/**
 * @generated SignedSource<<c7abd8d4cf7a2a517f97b0193bdb46ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemFooter_todo$data = {
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooterDone_todo" | "TodoListItemFooterPending_todo">;
  readonly " $fragmentType": "TodoListItemFooter_todo";
};
export type TodoListItemFooter_todo$key = {
  readonly " $data"?: TodoListItemFooter_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooter_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemFooter_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooterDone_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooterPending_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "2dc38b59f113b84ec59d591203116354";

export default node;
